import { useQuery } from "react-query";
import { cacheKey } from "./shared";
import { getGenres } from "frontend/src/api/genres/get-many";
export var useGenres = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.includeHidden, includeHidden = _c === void 0 ? false : _c;
    var _d = useQuery([cacheKey, includeHidden], function () {
        return getGenres({ includeHidden: includeHidden });
    }), data = _d.data, isFetching = _d.isFetching;
    return { genres: data, isFetching: isFetching };
};
